import { Box } from '@mui/material';

import { DropdownListItem } from './types';
import Icon from '../Icon/Icon';

export const getDropdownItemDisplayValue = (option: DropdownListItem) =>
  option?.displayValue?.toString?.() || option?.value || '';

export const getDropdownItemIcon = (option: DropdownListItem, iconSize = 16) => {
  if (option.icon) {
    return <Icon id={option.value} icon={option.icon} height={iconSize} width={iconSize} />;
  }

  return null;
};

export const getLabelWithIcon = (
  option: DropdownListItem,
  config?: { gap?: number; iconSize?: number; showIcon?: boolean }
) => {
  const { gap = 1, iconSize = 20, showIcon = false } = config || {};
  const icon = getDropdownItemIcon(option, iconSize);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} gap={gap}>
      {showIcon ? icon : null}
      {getDropdownItemDisplayValue(option)}
    </Box>
  );
};
